export default "__VITE_ASSET__BDf0SZEY__"